import { NeoMapCenterPointers } from 'src/common/components/map/NeoMap/types';

export const ADDRESS_LOADING_TEXT = 'در حال جستجو...';

export const TRANSCEIVER_MODES = {
  SENDER: 'SENDER',
  RECEIVER: 'RECEIVER',
  FAVORITE: 'FAVORITE',
} as const;

export const TRANSCEIVER_TITLES = {
  SENDER: 'فرستنده',
  RECEIVER: 'گیرنده',
  FAVORITE: 'مکان منتخب‌',
} as const;

export const TRANSCEIVER_POINTERS: { [key: string]: NeoMapCenterPointers } = {
  SENDER: 'ORIGIN',
  RECEIVER: 'DESTINATION',
  FAVORITE: 'FAVORITE',
} as const;

export const LOCATION_FORM_SUBMIT_TITLES = {
  SENDER: 'ثبت مبدا',
  RECEIVER: 'ثبت مقصد',
  FAVORITE: 'تایید آدرس ',
} as const;
